import { getEnvVar } from '@utils';

const ZENDESK_API_KEY = getEnvVar('ZENDESK_API_KEY'); // Ensure the environment variable is set.

// Function to initialize Zendesk only once and return a Promise
export default function initializeZendesk() {
  if (document.getElementById('ze-snippet')) return;

  const s = document.createElement('script');
  s.id = 'ze-snippet';
  s.async = true;
  s.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_API_KEY}`;
  document.head.appendChild(s);

  s.onload = () => window.zE('messenger', 'hide'); // start hidden if desired
}
